import EventStepper from 'Components/EventStepper';
import { StepperHeaderFormInputPair, StepperHeaderValuePair } from 'Components/EventStepper/components';
import { fm } from 'Components/FormatMessage';
import FormRow from 'Components/FormRow';
import FormSection from 'Components/FormSection';
import InputHandler from 'Components/InputHandler';
import { IFormContext, withFormContext } from 'Containers/FormContextHandler';
import { formatPartialDate } from 'Utility/date';
import * as React from 'react';
import { isEmpty } from 'Utility/ramdaReplacement';

const ThalamotomyForm = ({ formData, editing }: IFormContext<IThalamotomy>): React.JSX.Element => {
  return (
    <>
      <FormSection>
        <FormRow title="thalamotomyHifu.thalamotomy.date">
          <InputHandler
            name="date"
            type="PartialDate"
            formData={formData}
            editing={!!editing}
            dateDefault="now"
            isNotCancellable={true}
          />
        </FormRow>
        <FormRow title="thalamotomyHifu.thalamotomy.treatmentHospital">
          <InputHandler
            name="placeOfOperation"
            type="Radio"
            options={['HUS', 'TYKS', 'TAYS', 'KYS', 'OYS']}
            formData={formData}
            editing={!!editing}
          />
        </FormRow>
        <FormRow title="thalamotomyHifu.thalamotomy.treatmentType">
          <InputHandler
            name="typeOfOperation"
            type="Radio"
            formData={formData}
            editing={!!editing}
            options={['thalamotomyRight', 'thalamotomyLeft']}
            optionFormatter={(opt: string | number): React.JSX.Element => fm(`thalamotomyHifu.thalamotomy.opts.${opt}`)}
          />
        </FormRow>
      </FormSection>
      <FormSection>
        <EventStepper
          name="adverseEffects"
          formData={formData}
          stepLabelText={(d: IThalamotomyOrHifuTreatmentAdverseEffect): string => formatPartialDate(d.date)}
          stepContent={(d: IThalamotomyOrHifuTreatmentAdverseEffect): React.JSX.Element => (
            <React.Fragment>
              <StepperHeaderValuePair
                header={fm('thalamotomyHifu.adverseEffect')}
                value={
                  d.adverseEffects &&
                  !isEmpty(d.adverseEffects) &&
                  d.adverseEffects.map((e, i) => {
                    return <div key={i}>{fm(`thalamotomyHifu.opts.${e}`)}</div>;
                  })
                }
              />
              <StepperHeaderValuePair
                header={fm('thalamotomyHifu.adverseEffectAdditionalInformation')}
                value={d.additionalInformation}
              />
            </React.Fragment>
          )}
          addNewTextHeader="thalamotomyHifu.newAdverseEffect"
          addNewTextButton="thalamotomyHifu.newAdverseEffect"
          previousEventsTextHeader="thalamotomyHifu.previousAdverseEffects"
          noPreviousEventsTextHeader="thalamotomyHifu.noPreviousAdverseEffects"
          editingElements={(index: number, onChange: IFormData['onChange']): React.JSX.Element => (
            <React.Fragment>
              <StepperHeaderFormInputPair
                header={fm('general.date')}
                input={
                  <InputHandler
                    type="PartialDate"
                    editing={true}
                    name="date"
                    formData={{
                      onChange,
                      document: { date: formData.document.adverseEffects?.[index]?.date || '' },
                    }}
                    dateDefault="now"
                    isNotCancellable={true}
                    dateHook={{
                      dateHookFloor: formData.document.date,
                    }}
                  />
                }
              />
              <StepperHeaderFormInputPair
                header={fm('thalamotomyHifu.adverseEffect')}
                input={
                  <InputHandler
                    type="Checkbox"
                    name="adverseEffects"
                    editing={true}
                    formData={{
                      onChange,
                      document: { adverseEffects: formData.document.adverseEffects?.[index]?.adverseEffects },
                    }}
                    options={[
                      'dysarthria',
                      'stability',
                      'paresthesy',
                      'cramp',
                      'doubleImages',
                      'infection',
                      'sweating',
                      'cerebralHemorrhage',
                      'hallucination',
                      'suboptimalResponse',
                      'other',
                    ]}
                    optionFormatter={(opt: string | number): React.JSX.Element => fm(`thalamotomyHifu.opts.${opt}`)}
                  />
                }
              />
              <StepperHeaderFormInputPair
                header={fm('thalamotomyHifu.adverseEffectAdditionalInformation')}
                input={
                  <InputHandler
                    name="additionalInformation"
                    type="TextArea"
                    formData={{
                      onChange,
                      document: {
                        additionalInformation: formData.document.adverseEffects?.[index]?.additionalInformation,
                      },
                    }}
                    editing={true}
                    placeholder={'thalamotomyHifu.adverseEffectAdditionalInformation'}
                  />
                }
              />
            </React.Fragment>
          )}
          viewing={!editing}
        />
      </FormSection>
    </>
  );
};

export default withFormContext(ThalamotomyForm);
